import { render, staticRenderFns } from "./StoreOrderCardMobile.vue?vue&type=template&id=581a6243&scoped=true"
import script from "./StoreOrderCardMobile.vue?vue&type=script&lang=js"
export * from "./StoreOrderCardMobile.vue?vue&type=script&lang=js"
import style0 from "./StoreOrderCardMobile.vue?vue&type=style&index=0&id=581a6243&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581a6243",
  null
  
)

export default component.exports